import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Gallery } from '../components/Gallery';
import { ArtistStatement } from '../components/ArtistStatement';
import { About } from '../components/About';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-offwhite" data-id="element-259">
      <Navbar data-id="element-260" />
      <Hero data-id="element-261" />
      <Gallery data-id="element-262" />
      <ArtistStatement data-id="element-263" />
      <About data-id="element-264" />
      <Footer data-id="element-265" />
    </main>;
}